export default __webpack_public_path__ + "9cb13612af1317a665a229e7cf9091a8.svg";